import { overlays } from '@ecosystem/newron-design-system';
import React from 'react';

export interface FilterTrayContextType {
  setToast: (toast: { type: overlays.Notification; message: string | React.ReactNode }) => void;
}

export const FilterTrayContext = React.createContext<FilterTrayContextType>(null);

export function useFilterTrayContext(): FilterTrayContextType {
  const context = React.useContext(FilterTrayContext);
  if (!context) {
    throw new Error('useFilterTrayContext must be used within a FilterTrayContext.Provider');
  }
  return context;
}
